module.exports = __webpack_public_path__ + "img/change-percent.8dbfe2d3.svg";